import { EventEmitter } from 'events';
import { BaseService } from './BaseService';


/**
 * SDK Action loosely adheres to Flux Standard Action
 */
export interface SDKAction<PayloadType, MetaType = Record<string, unknown>> {
  readonly action: string;
  readonly payload?: PayloadType;
  readonly error?: boolean;
  readonly meta?: MetaType;
}

export interface Unsubscribe {
  (): void;
}

export interface Observer<T> {
  (action: T): void;
}

/**
 * A paired down, redux like, event stream for events that happen within the SDK
 */
export class SDKEventService extends BaseService {
  private emitter: EventEmitter;

  constructor() {
    super({});
    this.emitter = new EventEmitter();
  }

  dispatch(event: SDKAction<any>): void {
    this.emitter.emit(event.action, event);
  }

  subscribe<PayloadType, MetaType = any>(actionType: string, observer: Observer<SDKAction<PayloadType, MetaType>>): Unsubscribe {
    this.emitter.on(actionType, observer);
    return () => this.emitter.off(actionType, observer);
  }

}
